import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Contactpage from '../../components/Contactpage'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { useFetch } from '../../hooks/useFetch';
import { fetchContact } from '../../api/api';
import { useTranslation } from 'react-i18next';


const ContactPage = () => {
    const { t } = useTranslation();
    const { data, isLoading, error } = useFetch(["contact"], fetchContact);
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.contact')} pagesub={t('pageTitles.contactSub')} />
            <Contactpage isLoading={isLoading} error={error} contact={data?.data?.contact} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

